import { LeaderboardModal } from '../../modals';
export function leaderBoard() {
    return new LeaderboardModal({});
}
